import useFetch from "hooks/useFetch";
import React, { useEffect, useState } from "react";
import { Form, Card } from "react-bootstrap";
import "./CategoryLearningPaths.scss";

const CategoryLearningPath = ({ handleCategoryFilter }) => {
  const { get, error, data } = useFetch();
  const [category, setCategory] = useState("");
  const [categoryList, setCategoryList] = useState([]);

  const handleCheckbox = (e) => {
    if (e.target.checked) {
      setCategoryList([...categoryList, e.target.value]);
      handleCategoryFilter([...categoryList, e.target.value]);
    } else {
      setCategoryList(
        categoryList.filter((category) => category !== e.target.value)
      );
      handleCategoryFilter(
        categoryList.filter((category) => category !== e.target.value)
      );
    }
  };

  useEffect(() => {
    get("/categories");
  }, []);

  useEffect(() => {
    setCategory(data);
  }, [data]);

  return (
    <>
      {error && <h4>{error}</h4>}
      {category && (
        <Form className="col-lg-12 mx-auto text-center mb-3">
          {category.map((type) => (
            <div key={type.id} className="mb-3 d-inline">
              <Form.Check
                custom
                label={type.title}
                onChange={handleCheckbox}
                type="checkbox"
                value={type.id}
                id={`inline-checkbox-${type.id}`}
              />
            </div>
          ))}
        </Form>
      )}
    </>
  );
};

export default CategoryLearningPath;
